















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SjkShijuangailan extends Vue {
  @Prop()
  private test;
}
